export default __webpack_public_path__ + "static/media/icon-remove.d612d325.svg";